import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertLocalDateToUTC = (
    date: Date,
    isStartOfDay: boolean = true
): string => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const zonedDate = dayjs(date).tz(userTimezone);

    const converted = isStartOfDay
        ? zonedDate.startOf("day").utc()
        : zonedDate.endOf("day").utc();

    // Return UTC ISO string
    return converted.toISOString();
};
